<template>
  <div v-if="linksData && linksData.length">
    <div v-for="(item, index) in linksData" :key="index" :class="item.componentType === 'link' ? 'mb-c-10' : ''">
      <div v-if="item.componentType === 'link' && !item.component.icon">
        <a :href="item.component.uri" class="custom-payload-con"
          :style="{ borderColor: chatThemeSettings?.borderColor }" style="color: #0000ee;"
          @click="navigateLink(item.component.uri)">{{
            item.component.linkDesc }}</a>
      </div>
      <div class="text-center"
        v-if="item.componentType === 'link' && item.component.icon && item.component.icon === 'vdv'">
        <a :href="item.component.uri" class="custom-payload-con "
          :style="{ borderColor: chatThemeSettings?.borderColor }" style="color: #0000ee;" target="_blank">
          <div class="d-flex vdv_link position-relative justify-content-center">
            <span class="vdv_video_icon">
              <img src="/images/playbutton.png" class="img-fluid" alt="vdv video" />
            </span>
            <span>{{ item.component.linkDesc }}</span>
          </div>
        </a>
      </div>
      <div v-if="item.componentType === 'linkwithtile'">
        <a :href="item.component.uri"
          class="d-flex border-0 align-items-center justify-content-center py-4 w-100 ai_bg_card bg-white rounded_10 custom_box_shadow"
          @click="navigateLink(item.component.uri)">
          <div>
            <!-- <em :class="'primaryicon-' + iconMap(item.component.icon)" /> -->
            <component :is="item.component.icon" :theme-color="isGradient ? '#fff' : '#B3B3B3'" />
          </div>
          <div class="ml-2">
            {{ item.component.linkDesc }}
          </div>
        </a>
      </div>
    </div>
  </div>
</template>
<script>

import { ChatWidgetService } from '../../../Services/ChatWidgetService/ChatWidgetService';
import BuyAVehicle from '../AssistantAi/StartUpIcons/BuyAVehicle.vue';
import FindAVehicle from '../AssistantAi/StartUpIcons/FindAVehicle.vue';
import GetPreQualified from '../AssistantAi/StartUpIcons/GetPreQualified.vue';
import Mobile from '../AssistantAi/StartUpIcons/Mobile.vue';
import Models from '../AssistantAi/StartUpIcons/Models.vue';
import ReserveAVehicle from '../AssistantAi/StartUpIcons/ReserveAVehicle.vue';
import SalesSpecial from '../AssistantAi/StartUpIcons/SalesSpecial.vue';
import ScheduleService from '../AssistantAi/StartUpIcons/ScheduleService.vue';
import ScheduleTestDrive from '../AssistantAi/StartUpIcons/ScheduleTestDrive.vue';
import SellUsYourVehicle from '../AssistantAi/StartUpIcons/SellUsYourVehicle.vue';
import ServiceCoupons from '../AssistantAi/StartUpIcons/ServiceCoupons.vue';
import ValueYourTrade from '../AssistantAi/StartUpIcons/ValueYourTrade.vue';

export default {
  // eslint-disable-next-line vue/require-prop-types
  props: ['linksData', 'chatThemeSettings'],
  // computed: {
  //   ...mapState({
  //     chatThemeSettings: (state) => {
  //       return state?.commonSettings?.chatThemeSettings;
  //     },
  //   }),
  // },
  computed: {
    isGradient() {
      return this.chatThemeSettings?.isGradient || false;
    },
  },
  methods: {
    navigateLink(val) {
      if (location.hash === '#Transact' && val.includes('#Transact')) {

        location.reload();
      } else {
        ChatWidgetService.closeChatWidgetSession();
        if (sessionStorage.getItem('chatTextModal') !== null) {
          sessionStorage.removeItem('chatTextModal');
        }
      }
    },
    iconMap(icon) {
      if (icon == 'Mobile') {
        return 'mobile';
      }
      if (icon == 'Models' || icon == 'find-a-vehicle' || icon == 'buy-a-vehicle') {
        return 'Specific-Vehicle';
      }
      return icon;
    },
  },
  components: {
    'buy-a-vehicle': BuyAVehicle,
    'find-a-vehicle': FindAVehicle,
    'Get-Pre-Qualified': GetPreQualified,
    'Models': Models,
    'Mobile': Mobile,
    'Reserve-a-vehicle': ReserveAVehicle,
    'Sales-Special': SalesSpecial,
    'Schedule-Service': ScheduleService,
    'Sell-Us-Your-Vehicle': SellUsYourVehicle,
    'Service-Coupons': ServiceCoupons,
    'Value-Your-Trade': ValueYourTrade,
    'Schedule-Test-Drive': ScheduleTestDrive,
  }
}
</script>
<style lang="less" scoped>
.custom-payload-con {
  width: 100%;
  border: 1px solid #eee;
  border-radius: 5px;
  padding: 10px;
  display: block;
  font-size: 13px !important;
  text-align: center;
  text-decoration: underline !important;
  color: #0000ee !important;
}

.mb-c-10 {
  margin-bottom: 10px;

  &:last-child {
    margin-bottom: 0 !important;
  }
}

@media (min-width: 1900px) {
  .custom-payload-con {
    font-size: 15px !important;
    padding: 15px;
  }
}

@media (min-width: 2500px) {
  .custom-payload-con {
    font-size: 15px;
    padding: 15px;
  }
}

.vdv_video_icon img {
  filter: invert(1);
  height: 20px;
  width: 20px;
}

.vdv_link span {
  top: 0px;
}
</style>
